import { Component } from "@angular/core";
import { AuthService } from "../../shared/auth.service";

@Component({
    selector: "cal-access-denied",
    standalone: true,
    templateUrl: "./access-denied.component.html",
    styleUrls: ["../login/login.component.css"],
})
export class AccessDeniedComponent {
    constructor(private authService: AuthService) {}

    signOut(): void {
        this.authService.logout();
    }
}
